import { updateEnrollments } from "../redux/actions/enrollments-actions";
import { EnrollmentType } from "./enums/enrollment-type";

const steps = [
    { index: 0, url: "/", label: "Start", description: "Start" },
    {
      index: 1,
      url: "/Employee",
      label: "Emp. Data",
      description: "Enter Employee Data",
    },
    {
      index: 2,
      url: "/Dependents",
      label: "Dependents",
      description: "Enter Dependent Data",
    },
    {
      index: 3,
      url: "/Medical",
      label: "Medical",
      description: "Select Medical Plan",
    },
    {
      index: 4,
      url: "/Dental",
      label: "Dental",
      description: "Select Dental Plan",
    },
    {
      index: 5,
      url: "/Vision",
      label: "Vision",
      description: "Select Vision Plan",
    },
    {
      index: 6,
      url: "/Disability",
      label: "Disability",
      description: "Review Disability",
    },
    {
      index: 7,
      url: "/LifeInsurance",
      label: "Life Ins.",
      description: "Select Life Insurance",
    },
    { index: 8, url: "/FSA", label: "FSA", description: "Select FSA Plans" },
    { index: 9, url: "/Review", label: "Review", description: "Review" },
  ];
const Initialize = async (callApi, dispatch, navigate, path) => {

    if(!path)
        path = "Enrollments";

    const results = await callApi(path, "GET");
    if(!results.error){
      if(results.enrollmentTypeId === EnrollmentType.BenficiaryChange)
        navigate("/Beneficiaries");
      if(!results.effectiveDate)
        navigate("/");
      dispatch(updateEnrollments(results));
      if(results.currentStep)
        navigate(steps[results.currentStep].url);
    } else {
        if(results.error?.code === 409)
            navigate("/AlreadyEnrolled");
    }
}
 
export default Initialize;